<template>
  <div class="invite-person">
    <div class="content" :class="['type-' + activityInfo.activity_type]">
      <div class="p-line">
        <div class="flag" :style="{ left: getPercent(current, list) }">
          <div class="text"
            ><span class="iconfont icon-gou"></span
            ><span
              >已{{
                (activityInfo.activity_type == 2 ? '传播' : '邀请') + current
              }}人</span
            ></div
          >
        </div>
        <div class="p-line-content">
          <div
            class="p-current"
            :style="{ width: getPercent(current, list) }"
          ></div>
        </div>
      </div>
      <!--  -->
      <div class="dot-content">
        <div
          class="dot-item"
          :class="{ 'dot-item-active': current >= item }"
          v-for="(item, index) in list"
          :key="index"
          :style="{ opacity: item == 0 ? 0 : 1 }"
        >
          <div class="invite-num" v-if="item"
            >{{
              (activityInfo.activity_type == 2 ? '传播' : '邀请') + item
            }}人</div
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [0, 6, 10, 15]
    },
    current: {
      type: Number,
      default: 15
    },
    activityInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      info: {
        2: {
          text: '传播',
          startColor: '#FE3875',
          endColor: ' #FF2768'
        },
        3: {
          text: '邀请',
          startColor: '#8890FE',
          endColor: '#CD88FC'
        }
      }
    }
  },
  methods: {
    getPercent(current, list) {
      let cur = 0
      let percent = 0
      if (current <= list[0]) {
        cur = 0
      } else if (current >= list[list.length - 1]) {
        cur = list.length - 1
      } else {
        list.map((item, index) => {
          if (current >= item) {
            cur = index
          }
        })
        percent = (current - list[cur]) / (list[cur + 1] - list[cur])
      }
      let space = 1 / (list.length - 1)
      let res = space * cur + space * percent
      return (res * 100).toFixed(2) + '%'
    }
  }
}
</script>
<style lang="scss" scoped>
.invite-person {
  display: flex;
}
.content {
  width: 100%;
  position: relative;
  height: 18px;
  margin-top: 32px;
  margin-bottom: 30px;
  .p-line {
    position: absolute;
    width: calc(100% - 18px);
    height: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .p-line-content {
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.12);
      .p-current {
        background: linear-gradient(180deg, #ff88a3 0%, #ff2768 100%);
        width: 0;
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
      }
    }
    .flag {
      transform: translate(-50%, 0%);
      position: absolute;
      left: 0;
      bottom: 16px;
      z-index: 2;
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid #fe3875;
      .text {
        z-index: 1;
        padding: 0px 3px 0px 7px;
        height: 20px;
        border-radius: 9px;
        position: absolute;
        bottom: 7px;
        left: 50%;
        transform: translate(-50%, 0%);
        white-space: nowrap;
        font-size: 10px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
        background: #fe3875;
        .iconfont {
          font-size: 10px;
          color: #fff;
          margin-right: 2px;
        }
      }
    }
  }
  .dot-content {
    position: absolute;
    width: 100%;
    height: 18px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .dot-item {
      position: relative;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #ffffff;
      box-sizing: border-box;
      border: 3px solid #d2d0dd;
      .invite-num {
        white-space: nowrap;
        position: absolute;
        top: 21px;
        right: -5px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.36);
        line-height: 15px;
      }
    }
    .dot-item-active {
      border: 3px solid #fe3875;
      .invite-num {
        color: #6236ff;
        font-weight: 600;
      }
    }
  }
}
.type-1,
.type-2 {
  .p-current {
    background: linear-gradient(180deg, #ff88a3 0%, #ff2768 100%) !important;
  }
  .flag {
    border-top: 8px solid #fe3875 !important;
  }
  .text {
    background: #fe3875 !important;
  }
  .dot-item-active {
    border: 3px solid #fe3875 !important;
  }
  .invite-num {
    color: #fe3875 !important;
  }
}
.type-3 {
  .p-current {
    background: linear-gradient(90deg, #8890fe 0%, #cd88fc 100%) !important;
  }
  .flag {
    border-top: 8px solid #8890fe !important;
  }
  .text {
    background: linear-gradient(0deg, #8890fe 0%, #cd88fc 100%) !important;
  }
  .dot-item-active {
    border: 3px solid #c38afd !important;
  }
  .invite-num {
    color: #7e4dfe !important;
  }
}
</style>
